import React from 'react';
import { FailureStatus } from 'src/common/ui/StatusScreen';

/**
 * Page shown when the bootstrap gives up waiting for the caller's permissions: a sync
 * run that failed, or a status write that never landed.
 *
 * Deliberately NOT shown for a run that is merely slow. In both cases reached here,
 * no run holds ORCA's singleton key, so a refresh re-fires the trigger for real and
 * "refresh this page" is a true instruction rather than a platitude. A run still in
 * progress would discard that trigger and return the same reading, which is why it
 * keeps waiting instead — see WAIT_EXTENDED in {@link ./permissionSyncDecision}.
 *
 * Rendered in place of the app at whatever URL the user is on, like
 * {@link ./ProfileUnavailablePage}, so the refresh lands them where they meant to be.
 */
const PermissionsUnavailablePage: React.FC = () => (
  <FailureStatus heading="Couldn’t load your permissions">
    <p>Refresh this page to try again.</p>
  </FailureStatus>
);

export default PermissionsUnavailablePage;
